import { DocumentTextIcon } from '@heroicons/react/20/solid';
import { WorkpaperProcedure } from '../../types/workpaper-procedure';
import WorkpaperProcedureRoleBadge from './WorkpaperProcedureRoleBadge';
import WorkpaperProcedureTypeBadge from './WorkpaperProcedureTypeBadge';

export default function WorkpaperProcedureMeta({ workpaperProcedure }: { workpaperProcedure: WorkpaperProcedure }): JSX.Element {
    return (
        <div className="flex gap-2 items-center">
            {/* Procedure role */}
            <WorkpaperProcedureRoleBadge role={workpaperProcedure.role} />
            {/* Procedure entity type */}
            {workpaperProcedure.entityType && <WorkpaperProcedureTypeBadge entityType={workpaperProcedure.entityType} />}

            {/* Notes */}
            {workpaperProcedure.notes && workpaperProcedure.notes.length > 0 && (
                <>
                    <Dot />
                    <div className="flex items-center gap-1 text-gray-500">
                        <DocumentTextIcon className="w-4 h-4" />
                        <p className="text-sm">{workpaperProcedure.notes.length}</p>
                    </div>
                </>
            )}
        </div>
    );
}

function Dot(): JSX.Element {
    return <div className="h-1 w-1 rounded-full bg-gray-500"></div>;
}
